module.exports = __webpack_public_path__ + "media/icons/wallet-3ac65c39.png";